var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45039 1.77185C6.51572 1.77185 4.13477 4.03801 4.13477 6.82908C4.13477 10.0406 7.67852 15.1299 8.97974 16.8878C9.03375 16.962 9.10454 17.0224 9.18634 17.064C9.26813 17.1056 9.35861 17.1273 9.45039 17.1273C9.54217 17.1273 9.63265 17.1056 9.71445 17.064C9.79624 17.0224 9.86703 16.962 9.92105 16.8878C11.2223 15.1307 14.766 10.0432 14.766 6.82908C14.766 4.03801 12.3851 1.77185 9.45039 1.77185Z",
    stroke: "white",
    strokeWidth: 1.16382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44961 8.85942C10.4282 8.85942 11.2215 8.06613 11.2215 7.08755C11.2215 6.10897 10.4282 5.31567 9.44961 5.31567C8.47103 5.31567 7.67773 6.10897 7.67773 7.08755C7.67773 8.06613 8.47103 8.85942 9.44961 8.85942Z",
    stroke: "white",
    strokeWidth: 1.16382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFooter);
export default __webpack_public_path__ + "static/media/locationFooter.13d6507c5d08f31667cf659f909e439c.svg";
export { ForwardRef as ReactComponent };